import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router'
import { ROUTE_RECEIVABLES } from '@klear/constants'
import { useTrader } from '@klear/ui/hooks/use-trader'
import toInteger from 'lodash/toInteger'
import ReceivableWizard from '@/app/receivable/workflow/ReceivableWizard'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

export default function ReceivableWizardPage() {
  useDocumentTitle('New Receivable')
  const { traderId, orderId } = useParams<{ traderId?: string; orderId?: string }>()
  const navigate = useNavigate()
  const { urlPrefixApp } = useTrader(traderId)

  const orderIdSeed = orderId ? toInteger(orderId) : null

  const exitToList = useCallback(() => navigate(`${urlPrefixApp}/${ROUTE_RECEIVABLES}`), [navigate, urlPrefixApp])

  return <ReceivableWizard traderIdParam={traderId ?? ''} orderIdSeed={orderIdSeed} onBack={exitToList} />
}
